import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M-1-1h21v21H-1z" }),
      _createElementVNode("path", {
        fill: "#4A4A4A",
        "fill-rule": "nonzero",
        d: "M4.492 14.653a2.578 2.578 0 0 1 4.862 0h8.737v1.718H9.354a2.578 2.578 0 0 1-4.862 0H.909v-1.718zm5.154-6.012a2.578 2.578 0 0 1 4.862 0h3.583v1.718h-3.583a2.578 2.578 0 0 1-4.862 0H.909V8.64zM4.491 2.63a2.578 2.578 0 0 1 4.863 0h8.737v1.718H9.354a2.578 2.578 0 0 1-4.862 0H.909V2.629h3.583z"
      })
    ], -1)
  ]))]))
}
export default { render: render }